// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@awc/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface FiltersLayoutStyles {
    container?: InjectableCss;
    search?: InjectableCss;
    sort?: InjectableCss;
    show?: InjectableCss;
    pagination?: InjectableCss;
    leftSideContainer?: InjectableCss;
}

export const filtersLayoutStyles: FiltersLayoutStyles = {};

const styles = filtersLayoutStyles;
export const FiltersLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.leftSideContainer}>
                <StyledWrapper {...styles.search}>
                    <XngZone contentId={id} zoneName="Filters-layout-Search" hint="search" />
                </StyledWrapper>

                <StyledWrapper {...styles.sort}>
                    <XngZone contentId={id} zoneName="Filters-layout-Sort" hint="sort" />
                </StyledWrapper>

                <StyledWrapper {...styles.show}>
                    <XngZone contentId={id} zoneName="Filters-layout-Show" hint="show" />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.pagination}>
                <XngZone contentId={id} zoneName="Filters-layout-Pagination" hint="pagination" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule<FieldDefinition> = {
    component: FiltersLayout,
    definition: {
        group: "My Lists",
        displayName: "Filters Layout",
        icon: "distribute-spacing-vertical",
        allowedContexts: ["MyListsPage"],
    },
};

export default widgetModule;
